import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'MARKETview';

const ROUTE_TITLES: Record<string, string> = {
  '/home': 'Home',
  '/reports': 'Reports',
  '/files': 'My Files',
  '/goals': 'Goals',
  '/insights': 'Insights',
  '/profile': 'Profile',
  '/learn': 'Learn',
  '/learn/courses': 'Courses',
  '/learn/content/articles': 'Articles',
  '/learn/content/guides': 'Guides',
  '/learn/content/downloads': 'Downloads',
  '/learn/content/webinars': 'Webinars',
  '/learn/content/product-announcements': 'Announcements',
  '/learn/get-started-guide': 'Get Started Guide',
  '/admin/clients': 'Clients',
  '/admin/users': 'Users',
  '/admin/reports': 'Reports Management',
  '/admin/products': 'Products',
  '/admin/profile': 'Profile',
};

const ROUTE_TITLE_ENTRIES: Array<[string, string]> = Object.entries(
  ROUTE_TITLES
).sort(([a], [b]) => b.length - a.length);

const usePageTitle = (customTitle?: string): void => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (customTitle) {
      document.title = `${customTitle} | ${SITE_NAME}`;

      return;
    }

    const matchedTitle =
      ROUTE_TITLES[pathname] ||
      ROUTE_TITLE_ENTRIES.find(
        ([route]) => pathname === route || pathname.startsWith(`${route}/`)
      )?.[1];

    document.title = matchedTitle
      ? `${matchedTitle} | ${SITE_NAME}`
      : SITE_NAME;
  }, [pathname, customTitle]);
};

export default usePageTitle;
